module.exports = __webpack_public_path__ + "img/logo2.55962128.png";